import React from "react";
import classNames from "classnames/bind";
import styles from "./MobileNavigation.module.scss";
import { Link } from "react-router-dom";

const cx = classNames.bind(styles);

const MobileNavigation = ({
  menuItems,
  activeMobileDropdown,
  toggleMobileDropdown,
  onClose,
}) => {

  const renderItemParenMenu = (item, index) => {
    if (item.dropdown) {
      return (
        <div
          className={cx("mobile-navigation__link-wrapper")}
          onClick={(e) => {
            e.preventDefault();
            toggleMobileDropdown(index);
          }}
        >
          <span className={cx("mobile-navigation__link")}>
            {item.name}
          </span>

          <span
            className={cx("mobile-navigation__dropdown-arrow", {
              "mobile-navigation__dropdown-arrow--active":
                activeMobileDropdown === index,
            })}
          >
            ▼
          </span>
        </div>
      );
    } else {
      return (
        <Link
          to={`/${item.key.toLowerCase().replace("_", "-")}`}
          className={cx("mobile-navigation__link-wrapper")}
        >
          <span
            className={cx("mobile-navigation__link")}
            onClick={!item.dropdown ? onClose : undefined}
          >
            {item.name}
          </span>
        </Link>
      );
    }
  };

  return (
    <nav className={cx("mobile-navigation")}>
      {menuItems.map((item, index) => (

        <div key={item.key} className={cx("mobile-navigation__item")}>
          {renderItemParenMenu(item, index)}

          {item.dropdown && activeMobileDropdown === index && (
            <div className={cx("mobile-navigation__category-list")}>
              <h4 className={cx("mobile-navigation__category-title")}>
                {item.dropdown.title}
              </h4>
              {Object.entries(item.dropdown)
                .filter(([catKey]) => catKey !== "title")
                .map(([catKey, catLabel]) => (
                  <Link
                    key={catKey}
                    to={`/products/category/${catKey.split(" ").join("-")}`}
                    className={cx("mobile-navigation__category-link")}
                    onClick={onClose}
                  >
                    {catLabel}
                  </Link>
                ))}
            </div>
          )}
        </div>
      ))}
    </nav>
  );
};

export default MobileNavigation;
